var isObject = require('./_is-object');
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};



//////////////////
// WEBPACK FOOTER
// /home/abuild/rpmbuild/BUILD/Portus-v2.3/~/core-js/modules/_an-object.js
// module id = 17
// module chunks = 0